import { useMemo } from 'react'
import { routes } from '@/routes'
import { generatePath, useNavigation } from '@sevenrooms/navigation'

export const useManageReservationRoute = () => {
  const { matchQuery, matchParams } = useNavigation()
  const { venueKey } = matchParams(routes.reservations) ?? {}
  const {
    lang = 'en',
    token = '',
    is_confirm: isConfirm,
    is_success: isSuccess,
    is_success_edit: isSuccessEdit,
    marketing_opt_in: marketingOptIn,
  } = matchQuery(routes.reservations.manage) ?? {}
  const linkToModifyReservation = useMemo(() => generatePath(routes.direct.modifyReservation.path, { token }, { lang }), [token, lang])
  const linkToPurchaseUpgrades = useMemo(
    () => generatePath(routes.direct.modifyReservation.path, { token }, { lang, source: 'prearrival' }),
    [token, lang]
  )

  return {
    token,
    isConfirm: isConfirm === 'true',
    isSuccess: isSuccess === 'true',
    isSuccessEdit: isSuccessEdit === 'true',
    marketingOptIn: marketingOptIn === 'true',
    lang,
    venueKey,
    linkToModifyReservation,
    linkToPurchaseUpgrades,
  }
}
